// action - state management
import * as actionTypes from '../../actionTypes'
import { updateObject } from '../../shared/utility'

export const initialState = {
    business_sector: "",
    main_goal: "",
    monthly_budget: "",
    recommendations: [],
    user_id: [],
}

// ==============================|| GOALRECOMANDATIONS REDUCER ||============================== //

const goalRecompandationReducers = (state = initialState, action: any) => {
  switch (action.type) {

    case actionTypes.RESET_STATE: return initialState
    
    case actionTypes.USER_GOAL_SETUP_SUCCESS:
      return updateObject(state, {
        loading: false,
        data: action.data,
        error: null
    })
    case actionTypes.USER_GOAL_SETUP_FAILURE: 
    return updateObject(state, {
        loading: false,
        data: null,
        error: action.data
      })
    default:
      return state
  }
}

export default goalRecompandationReducers
